module.exports = __webpack_public_path__ + "img/terrain.deac1126.png";